module.exports = {
  dsn: 'https://16a8291a236a41fe8f36d3fd90c09774@sentry.io/173759',

  options: {
  // List of common ignore rules from https://docs.sentry.io/clients/javascript/tips/
    ignoreErrors: [
      /Blocked a frame with origin/,
      // Random plugins/extensions
      'top.GLOBALS',
      // See: https://blog.errorception.com/2012/03/tale-of-unfindable-js-error. html
      'originalCreateNotification',
      'canvas.contentDocument',
      'MyApp_RemoveAllHighlights',
      'https://tt.epicplay.com',
      'Can\'t find variable: ZiteReader',
      'jigsaw is not defined',
      'ComboSearch is not defined',
      'https://loading.retry.widdit.com/',
      'atomicFindClose',
      // happening only for old android devices (<= 4.4) so it's probably safe to ignore
      'INVALID_STATE_ERR: DOM Exception 11',
      // happening only for android 7.1.1, chrome mobile 45.0.2454
      'Cannot read property \'end\' of undefined',
      'Cannot read property \'DOMNodeInsertedByJs\' of undefined',
      'Cannot read property \'onWindowLoaded\' of undefined',
      // Facebook borked
      'fb_xd_fragment',
      // ISP "optimizing" proxy - `Cache-Control: no-transform` seems to
      // reduce this. (thanks @acdha)
      // See https://stackoverflow.com/questions/4113268
      'bmi_SafeAddOnload',
      'EBCallBackMessageReceived',
      // See https://toolbar.conduit.com/Developer/HtmlAndGadget/Methods/JSInjection.aspx
      'conduitPage',
      // failed to load favicon, url seems to be working, we can probably ignore this for now...
      // Only seems to be for Chrome v.57.0.2987 and Windows 10, can't replicate
      'Failed to execute \'send\' on \'XMLHttpRequest\': Failed to load \'https://images.hu-production.be/static/favicon.png\'.',
      'Non-Error promise rejection captured', // TECH-52

      // not much we can do about the user's internet connection being rubbish
      'Network Error',

      // Login error messages
      'Email/password combination isn\'t right or email already in use',
      'La combinación de correo electrónico / contraseña no es correcta o el correo electrónico ya está en uso', //es
      'A combinação de e-mail / senha não está correta ou o e-mail já está em uso', //pt
      'It looks like you left your email address out. Add it and try again!',
      'This email address has already been registered. Already a member? Try \'Log in\' below.',
      'Your account has been locked. Please reset your password',
      'Sua conta foi bloqueda. Por favor modifique sua senha para continuar', //pt

      // 314 Community not found
      '314: Error fetching community',
      '314 User is being shown an oops page',
      // 404
      'Request failed with status code 404',
      '404: Post error',
      '404: This is a private community',
      // 410 GONE (normally means a post was deleted)
      'Request failed with status code 410',
      '410 User is being shown an oops page',
      '410: Post error',
      // 401
      'Request failed with status code 401',
      '401: This page is not available to visitors',
    ],
    whitelistUrls: [
      /d3pv2lg0hr7u1j.cloudfront.net/i,
      /assets.hu-production.be/i,
      /assets.hu-production.be/i,
      /assets.hu-production.be/i,
      /assets.hu-staging.be/i,
    ],
  },
};
